/* import __COLOCATED_TEMPLATE__ from './parenthesis.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();